import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import InnerLayout from "../innerLayout/InnerLayout";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import { CenterModal, RightModal } from "../../components/sideModal/Modal";
import { PlayerWithScreenshots, getPlayers, getPlayersScreenshots } from "../../../api/playersApi";
import "./PlayersMonitoring.css";
import Select, { MultiValue } from "react-select";
import { Guid } from "../../../api/baseApi";
import { formatDate, formatTime } from "../../../services/dateService";
import { Button } from "../../components/Button";
import { Routes, createPathWithId } from "../../../constants/routes";
import { ReactSortable } from "react-sortablejs";
import { FormInput, FormRow } from "../../components/formRow/FormRow";
import IconButton from "../../components/iconButton/IconButton";
import Tabs, { TabElement, TabNavigation, TabNavigationElement, TabsContainer } from "../../components/tab/Tab";
import PlayerSystemMonitor from "../../components/playerMonitor/PlayerMonitor";

interface PlayersMonitoringProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string}
type MonitoringGroup = {
    id: string,
    groupTitle: "Default" | string,
    playerIds: string[]
}

type ModalAction = "create" | "update" | "nothing";
interface CheckedItems {
    [key: string]: boolean;
}
type SettingsTab = "Monitoring" | "PlayerMonitor";

const PlayersMonitoring: FunctionComponent<PlayersMonitoringProps> = (props : PlayersMonitoringProps) => {
    let {history} = props;

    let [isLoading, setIsLoading] = useState(false);
    let [currentScreenShot, setCurrentScreenShot] = useState('');
    let [showScreenModal, setShowScreenModal] = useState(false);
    let [players, setPlayers] = useState<Option<Guid>[]>([]);
    let [selectedPlayers, setSelectedPlayers] = useState<Guid[]>([]);
    let [playersWithScreenshots, setPlayersWithScreenshot] = useState<PlayerWithScreenshots[]>([]);
    let [lastUpdate, setLastUpdate] = useState("");

    let [isShowGroupModal, setIsShowGroupModal] = useState(false)
    let [groupName, setGroupName] = useState("");
    let [isGroupNameError, setIsGroupNameError] = useState(false);
    let [groupNameErrorMessage, setGroupNameErrorMessage] = useState("");
    let [monitoringGroupAction, setMonitoringGroupAction] = useState<ModalAction>("nothing");
    let [groupIdForAction, setGroupIdForAction] = useState("")

    let [monitoringGroups, setMonitoringGroups] = useState<MonitoringGroup[]>([])
    let [checkedItems, setCheckedItems] = useState<CheckedItems>({})
    let [isListCollapsed, setIsListCollapsed] = useState(false)

    let [activeTab, setActiveTab] = useState<SettingsTab>("Monitoring");

    useEffect(()=>{
        async function fetchData() {
            setIsLoading(true);
            await updatePlayersList();
            setSelectedPlayers(getPlayerIdsFromLocaleStorage())
            setMonitoringGroups(getMonitoringState())

            const initialCheckedItems: CheckedItems = {};
            getMonitoringState().forEach(item => {
                initialCheckedItems[item.id] = true;
            });
            setCheckedItems(initialCheckedItems);

            setIsLoading(false);
        };
        
        
        fetchData()
        let refetchInterval = setInterval(async () => {
            await updatePlayersScreenshots();
        }, 300000)

        return () => {
            clearInterval(refetchInterval)
        }
    },[])

    useEffect(()=>{
        async function fetchData() {
            await updatePlayersScreenshots();
        };
        fetchData()
    },[selectedPlayers])

    useEffect(() => {
        const allChecked = Object.values(checkedItems).every((checked) => checked);
        if(allChecked) setIsListCollapsed(false)
        else setIsListCollapsed(true)
    },[checkedItems])

    const saveCurrentMonitoringState = (data: MonitoringGroup[]) => {
        setMonitoringGroups(data)
        localStorage.setItem('monitoring', JSON.stringify(data))
    }

    const updatePlayersList = async () => {
        let result = await getPlayers();
        setPlayers(result.players.map(player => {
            return {
                label: player.name ? player.name : '',
                value: player.id
            }
        }));
        refreshUpdateTime()
    }

    function getMonitoringState () {
        const monitoring = localStorage.getItem('monitoring')

        if (!monitoring) {
            localStorage.setItem('monitoring', JSON.stringify([{id: '44', groupTitle:"Default", playerIds:[]}]))
            return [{id: '44', groupTitle:"Default", playerIds:[]}]
        }

        const monitoringArr:MonitoringGroup[] = JSON.parse(monitoring)

        return monitoringArr
    }

    function addPlayerIdsToGroup(groupTitle: string, newPlayerIds: Guid[], withReplace:boolean = false) {
        const groupIndex = monitoringGroups.findIndex(group => group.groupTitle === groupTitle);

        if (groupIndex !== -1) {
            const updatedMonitoringGroups = [...monitoringGroups];
        
            const existingPlayerIds = updatedMonitoringGroups[groupIndex].playerIds;
            const uniqueNewPlayerIds = newPlayerIds.filter(id => !existingPlayerIds.includes(id));
            const idsForInsert = withReplace ? [...newPlayerIds] : [...existingPlayerIds, ...uniqueNewPlayerIds]
            updatedMonitoringGroups[groupIndex] = {
                ...updatedMonitoringGroups[groupIndex],
                playerIds: idsForInsert
            };
        
            saveCurrentMonitoringState(updatedMonitoringGroups)
        }
    }

    const removePlayerIdFromGroups = (playerId:Guid) => {
        const updatedMonitoringGroups = monitoringGroups.map(group => {
            return {
            ...group,
            playerIds: group.playerIds.filter(id => id !== playerId)
            };
        });
        
        saveCurrentMonitoringState(updatedMonitoringGroups)
    }

    const getPlayerIdsFromLocaleStorage = () => {
        let ids = getMonitoringState().flatMap(item => item.playerIds);
        return ids
    }

    const refreshUpdateTime = () => {
        setLastUpdate(formatTime(new Date().toISOString()))
    }

    const updatePlayersScreenshots = async () => {
        const result = await getPlayersScreenshots({ playerIds: getPlayerIdsFromLocaleStorage() });
        if (result.type === "succes") {
            setPlayersWithScreenshot(result.data.data.players);
            refreshUpdateTime()
        }
    }

    const forceUpdatePlayersScreenshots = async () => {
        setIsLoading(true);
        await updatePlayersScreenshots();
        refreshUpdateTime();
        setIsLoading(false);
    }

    const showScreenInModal = (screenShotUrl: string) => {
        setShowScreenModal(true);
        setCurrentScreenShot(screenShotUrl);
    }

    const hideScreenModal = () =>{
        setShowScreenModal(false);
        setCurrentScreenShot('');
    }

    const onChangeSelectedPlayers = (values: MultiValue<Option<Guid>>) => {
        let ids = values.map(it => it.value);
        setSelectedPlayers([...ids]);
        ids = findNonIntersectingElements(selectedPlayers, ids)
        addPlayerIdsToGroup("Default", ids)
    }

    function findNonIntersectingElements(selectedIds: Guid[], newIds: Guid[]) {
        const result: Guid[] = [];
    
        for (const id of newIds) {
            if (!selectedIds.includes(id)) {
                result.push(id);
            }
        }
    
        return result;
    }

    const goToPlayerConfiguration = (playerId: string) => {
        const data = {startConfigure: true}
        history.push(createPathWithId(Routes.Players, playerId), data)
    }

    const goToStream = (listId: Guid | null, streamId: Guid | null) => {
        const data = streamId
        if(listId && streamId){
            history.push(createPathWithId(Routes.PriorityList, listId), data)
        }
    }

    const renderPlayerRow = (items: PlayerWithScreenshots[]) => {
        return items.map( (it) => {
            return <div className="player-screenshots__elem" key={it.id} >
                <div className="player-screenshots__name">
                    <span className="player-screenshots__name-txt" onClick={()=>{goToPlayerConfiguration(it.id)}}>{it.playerName} </span>
                    <span className="player-screenshots__close" onClick={()=>{removeSelectedPlayerByClick(it.id)}}>x</span>
                </div>
                <div className="player-screenshots__area">
                    {it.screenshots.map( (s,i) => {
                        return <div className="player-screenshots__block" key={i}>
                            <img className="player-screenshots__img" src={s.previewUrl} alt="" onClick={()=>showScreenInModal(s.screenshotUrl)} />
                            <p className="">{formatDate(s.dateTime)} {formatTime(s.dateTime)}</p>
                            <p className="player-screenshots__info" onClick={()=>{goToStream(s.priorityListId,s.streamId)}}>{s.siteInfo}</p>
                            {s.isOffline && <div className="offline-layer"></div>}
                        </div>
                    })}
                </div>
            </div>
        })
    }

    const removeMonitoringGroup = (id:Guid) => {
        const groupIndex = monitoringGroups.findIndex(group => group.id === id);
        let updatedMonitoringGroups = [...monitoringGroups]
        if(groupIndex !== -1) {
            let ids = selectedPlayers.filter( el => {
                return !updatedMonitoringGroups[groupIndex].playerIds.includes(el)
            })
            setSelectedPlayers(ids)
            updatedMonitoringGroups.splice(groupIndex,1)
            saveCurrentMonitoringState(updatedMonitoringGroups)
        }
    }

    const renderPlayerGroupRow = (items: MonitoringGroup[]) => {
        return items.map( (el, index) => {
            let screenshotsToRender = el.playerIds.map( plI => {
                let index = playersWithScreenshots.findIndex( p => p.id === plI)
                return playersWithScreenshots[index] 
            }).filter(item => !!item)


            return <div className="player-screenshots__group" key={el.id}>
                <h3 className="player-screenshots__group-title">
                    {el.groupTitle}
                    {el.groupTitle !== "Default" && <IconButton tooltipText="Edit" type="edit" onClick={() => {showGroupModal("update",el)}}/>}
                    {el.groupTitle !== "Default" && <IconButton tooltipText="Delete" type="delete" onClick={() => {removeMonitoringGroup(el.id)}}/>}
                    <div className="d-inline-flex justify-content-end player-screenshots__expand-block">
                        <label htmlFor={`group-${index}`} className="checkbox-control">
                            <input 
                                id={`group-${index}`} 
                                className="checkbox" 
                                type="checkbox" 
                                checked={!!checkedItems[el.id]}
                                onChange={() => handleCheckboxChange(el.id)}
                            />
                            <span className="checkbox-bg"></span>
                            <span className="checkbox-cursor"></span>
                        </label>
                        <span className="current-status">&nbsp;Expand</span>
                    </div>
                </h3>

                {playersWithScreenshots.length !== 0 && <ReactSortable 
                    list={screenshotsToRender}
                    setList={(newState) => {
                        let newIds = newState.map( i => i.id )
                        if(newIds.length > 0){
                            addPlayerIdsToGroup(el.groupTitle, newIds, true)
                        } else {
                            addPlayerIdsToGroup(el.groupTitle, newIds, true)
                        }
                    }}
                    group={"test"}
                    tag="div"
                    className="player-screenshots__row"
                    animation={150}
                    fallbackOnBody={true}
                    swapThreshold={0.65}
                >
                    {screenshotsToRender.length ? renderPlayerRow(screenshotsToRender) : <p className="no">Please select player</p>}
                </ReactSortable>}
            </div>
        })
    }

    const removeSelectedPlayerByClick = (playerId: string) => {
        let newIds = selectedPlayers.filter(el => el !== playerId)
        setSelectedPlayers(newIds)
        removePlayerIdFromGroups(playerId)
    }

    const showGroupModal = (action: ModalAction, group?: MonitoringGroup) => {
        
        if(group){
            setGroupName(group.groupTitle)
            setGroupIdForAction(group.id)
        }
        setMonitoringGroupAction(action)
        setIsShowGroupModal(true)
    }

    const hideGroupModal = () => {
        setIsGroupNameError(false)
        setGroupName("")
        setGroupIdForAction("")
        setMonitoringGroupAction("nothing")
        setIsShowGroupModal(false)
    }

    const createNewMonitoringGroup = async () => {
        if(groupName === "") {
            setIsGroupNameError(true);
            setGroupNameErrorMessage("Please enter Group Name")
            return;
        }
        
        let groupIndex = monitoringGroups.findIndex(g => g.groupTitle === groupName)

        if(groupIndex !== -1){
            setIsGroupNameError(true);
            setGroupNameErrorMessage("This Group is already exists")
            return;
        }
        
        if(monitoringGroupAction === "create"){

            let newGroup: MonitoringGroup = {
                id: new Date().toString(),
                groupTitle:groupName,
                playerIds: []
            };
    
            let newGroupState = [...monitoringGroups, newGroup]
            saveCurrentMonitoringState(newGroupState)
        }

        if(monitoringGroupAction === "update"){
            let groupIndex = monitoringGroups.findIndex( g => g.id === groupIdForAction)
            monitoringGroups[groupIndex].groupTitle = groupName
            saveCurrentMonitoringState(monitoringGroups)
        }

        hideGroupModal()
    }

    const handleCheckboxChange = (id: string) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const toggleAllCheckboxes = () => {
        const allChecked = Object.values(checkedItems).every((checked) => checked);
        const newCheckedItems: CheckedItems = monitoringGroups.reduce((acc, item) => {
            acc[item.id] = !allChecked;
            return acc;
        }, {} as CheckedItems);
        setCheckedItems(newCheckedItems);
        setIsListCollapsed( prev => !prev)
    };

    const checkActive = (tab: SettingsTab) =>  tab === activeTab;
    
    return (  
        <InnerLayout 
            isCollapsed={props.isCollapsed}
            logOut={props.logOut}
            toogleCollapse={props.toogleCollapse}
            activeTab="monitoring">
                <div className="monitoring-wrapper">
                <Tabs>
                <TabNavigation>
                    <TabNavigationElement 
                        title="Monitoring" 
                        isActive={checkActive("Monitoring")} 
                        onClick={() => { setActiveTab("Monitoring") }} 
                    />
                    <TabNavigationElement 
                        title="Player System Monitor" 
                        isActive={checkActive("PlayerMonitor")} 
                        onClick={() => { setActiveTab("PlayerMonitor") }} 
                    />
                </TabNavigation>
                <TabsContainer>
                    <TabElement isActive={checkActive("Monitoring")}>
                        <>
                        <div className="d-flex justify-content-between align-items-center mb-40 gap15" >
                            <h2 style={{"marginBottom":0}}>Player Monitor Dashboard</h2>

                            <div className="d-flex justify-content-start align-items-center gap15" style={{"width":"50%"}}>
                                <div style={{"width":"50%"}}>
                                    <Select 
                                        options={players}
                                        className="custom-height-select"
                                        isMulti
                                        value={players.filter(p => selectedPlayers.includes(p.value))}
                                        classNamePrefix={`select`}
                                        onChange={onChangeSelectedPlayers} 
                                    /> 
                                </div>
                                <div className="d-flex align-items-center gap15">
                                    <span style={{"fontSize":"12px", "opacity":"0.5"}}>Last update: {lastUpdate}</span>
                                    <Button color="green" label="Update Screenshots" onClick={forceUpdatePlayersScreenshots}  />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end align-items-center">
                                <Button color="green" label="Add Group" onClick={() => {showGroupModal("create")}}  />
                            </div>
                        </div>

                        <div className="d-flex align-items-center mb-20 w-100">
                            <Button color="green" label={`${isListCollapsed ? "Full List" : "Compact View"}`} onClick={toggleAllCheckboxes}  />
                        </div>

                        {monitoringGroups.length > 0 && <ReactSortable 
                            list={monitoringGroups}
                            setList={(newState) => {
                                saveCurrentMonitoringState(newState)
                            }}
                            tag={"div"}
                            className="player-screenshots"
                        >
                            {renderPlayerGroupRow(monitoringGroups)}
                        </ReactSortable>}
                        </>
                    </TabElement>
                    <TabElement isActive={checkActive("PlayerMonitor")}>
                        <div className="w-100">
                        {checkActive("PlayerMonitor") && <PlayerSystemMonitor />}
                        </div>
                    </TabElement>
                </TabsContainer>
                </Tabs>

                    <CenterModal title="Player Screenshot" show={showScreenModal} onRequestClose={hideScreenModal}>
                        {currentScreenShot && <div className="screen">
                            <img className="screen-img in-modal" src={currentScreenShot} alt="" />
                        </div>}
                    </CenterModal>

                    <RightModal title={`${monitoringGroupAction === "update" ? "Edit" : "Add"} Group`} show={isShowGroupModal} onRequestClose={hideGroupModal}>
                        <FormRow> 
                            <FormInput 
                                errorMessage = {groupNameErrorMessage}
                                id = "media_group_name"
                                isError = {isGroupNameError}
                                title = "Group Name"
                                onChangeValue = {(v) => {setGroupName(v); setIsGroupNameError(false)}}
                                value = {groupName}
                            />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label={`${monitoringGroupAction === "update" ? "Save" : "Add"}`} onClick={createNewMonitoringGroup}/>
                            <Button color="gray" label="Cancel" onClick={hideGroupModal}/>
                        </div>
                    </RightModal> 
                    <GlobalSpinner isShow={isLoading} />
                </div>
               
        </InnerLayout> );
}

export default withRouter(PlayersMonitoring)